import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styles from './styles.module.scss';

const ConfirmDelete = ({
                         open,
                         closeModal,
                         fileName,
                         onConfirm
                       }) => {
  return (
    <Modal
      isOpen={open}
      onRequestClose={closeModal}
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <div className={styles.deleteModal}>
        <h2 className={styles.title}>אישור הסרת קובץ</h2>
        <div className={styles.text}>
          האם אתה בטוח שברצונך להסיר את קובץ ' <span>{fileName}</span>'?
        </div>
        <div className={styles.buttons}>
          <button
            onClick={e => {
              e.preventDefault();
              closeModal();
            }}
            className={classnames(styles.actionBtn, styles.actionCancel)}
          >
            ביטול
          </button>
          <button
            onClick={e => {
              e.preventDefault();
              onConfirm();
              closeModal();
            }}
            className={classnames(styles.actionBtn, styles.actionDelete)}
          >
            אישור
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmDelete.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  fileName: PropTypes.string,
  onConfirm: PropTypes.func,
};

export default ConfirmDelete;
